// jQuery plugins
import $ from './globals/jquery'; // eslint-disable-line
import '@pixelunion/jquery-trend';
import '@pixelunion/jquery-revealer';

import scriptjs from 'scriptjs';
import rimg from '@pixelunion/rimg-shopify';
import { SiteAgeGate, PageAgeGate } from '@pixelunion/age-gate';

// Template imports
import Account from './templates/Account';
import Contact from './templates/Contact';
import Page from './templates/Page';
import GiftCard from './templates/GiftCard';

// Section imports
import Sections from './Sections';
import DynamicBlogPosts from './sections/DynamicBlogPosts';
import DynamicCollectionList from './sections/DynamicCollectionList';
import DynamicFeaturedCollection from './sections/DynamicFeaturedCollection';
import DynamicHighlightsBanners from './sections/DynamicHighlightsBanners';
import DynamicMap from './sections/DynamicMap';
import DynamicMenuList from './sections/DynamicMenuList';
import DynamicNewsletter from './sections/DynamicNewsletter';
import DynamicPromoBlocks from './sections/DynamicPromoBlocks';
import DynamicRichText from './sections/DynamicRichText';
import DynamicSearch from './sections/DynamicSearch';
import DynamicTestimonials from './sections/DynamicTestimonials';
import DynamicVideo from './sections/DynamicVideo';
import StaticAnnouncement from './sections/StaticAnnouncement';
import StaticArticle from './sections/StaticArticle';
import StaticBlog from './sections/StaticBlog';
import StaticCart from './sections/StaticCart';
import StaticCollection from './sections/StaticCollection';
import StaticCollectionFaceted from './sections/StaticCollectionFaceted';
import StaticCollectionMinimal from './sections/StaticCollectionMinimal';
import StaticPassword from './sections/StaticPassword';
import StaticProduct from './sections/StaticProduct';
import StaticProductRecommendations from './sections/StaticProductRecommendations';
import StaticRecentlyViewed from './sections/StaticRecentlyViewed';
import StaticSearch from './sections/StaticSearch';
import StaticSectionFooter from './sections/StaticSectionFooter';
import StaticSectionHeader from './sections/StaticSectionHeader';
import StaticSlideshow from './sections/StaticSlideshow';
import StaticUtilityBar from './sections/StaticUtilityBar';

import polyfillUrls from './checkPolyfills';

import ContainSwatchTooltips from './helpers/ContainSwatchTooltips';
import flickityTouchFix from './helpers/FlickityTouchFix';

const sectionMap = [
  { handle: 'dynamic-blog-posts', SectionClass: DynamicBlogPosts },
  { handle: 'dynamic-collection-list', SectionClass: DynamicCollectionList },
  { handle: 'dynamic-featured-collection', SectionClass: DynamicFeaturedCollection },
  { handle: 'dynamic-featured-product', SectionClass: StaticProduct },
  { handle: 'dynamic-highlights-banners', SectionClass: DynamicHighlightsBanners },
  { handle: 'dynamic-map', SectionClass: DynamicMap },
  { handle: 'dynamic-menu-list', SectionClass: DynamicMenuList },
  { handle: 'dynamic-newsletter', SectionClass: DynamicNewsletter },
  { handle: 'dynamic-promo-grid', SectionClass: DynamicPromoBlocks },
  { handle: 'dynamic-promo-mosaic', SectionClass: DynamicPromoBlocks },
  { handle: 'dynamic-rich-text', SectionClass: DynamicRichText },
  { handle: 'dynamic-search', SectionClass: DynamicSearch },
  { handle: 'dynamic-testimonials', SectionClass: DynamicTestimonials },
  { handle: 'dynamic-video', SectionClass: DynamicVideo },
  { handle: 'static-announcement', SectionClass: StaticAnnouncement },
  { handle: 'static-article', SectionClass: StaticArticle },
  { handle: 'static-blog', SectionClass: StaticBlog },
  { handle: 'static-cart', SectionClass: StaticCart },
  { handle: 'static-collection', SectionClass: StaticCollection },
  { handle: 'static-collection-faceted-filters', SectionClass: StaticCollectionFaceted },
  { handle: 'static-collection-minimal', SectionClass: StaticCollectionMinimal },
  { handle: 'static-footer', SectionClass: StaticSectionFooter },
  { handle: 'static-header', SectionClass: StaticSectionHeader },
  { handle: 'static-password', SectionClass: StaticPassword },
  { handle: 'static-product', SectionClass: StaticProduct },
  { handle: 'static-product-recommendations', SectionClass: StaticProductRecommendations },
  { handle: 'static-recently-viewed', SectionClass: StaticRecentlyViewed },
  { handle: 'static-search', SectionClass: StaticSearch },
  { handle: 'static-slideshow', SectionClass: StaticSlideshow },
  { handle: 'static-utility-bar', SectionClass: StaticUtilityBar },
  { handle: 'age-gate', SectionClass: PageAgeGate }
];

const initTheme = () => {
  rimg.init('[data-rimg="lazy"]', { round: 1 });

  const sections = new Sections();

  const prioritySections = document.querySelectorAll('[data-section-index="1"], [data-section-index="2"], [data-section-index="3"]');
  const priorityQueue = sectionMap.filter(({ handle }) =>
    [...prioritySections].some(el => el.dataset.sectionType === handle)
  );
  const secondaryQueue = sectionMap.filter(({ handle }) =>
    ![...prioritySections].some(el => el.dataset.sectionType === handle)
  );

  priorityQueue.forEach(({ handle, SectionClass }) => {
    sections.register(handle, section => new SectionClass(section));
  });

  secondaryQueue.forEach(({ handle, SectionClass }) => {
    sections.register(handle, section => new SectionClass(section));
  });

  new ContainSwatchTooltips();

  if ($('body.giftcard').length) {
    new GiftCard();
  }

  new Account();
  new Contact();
  new Page();

  flickityTouchFix();
};

if (polyfillUrls.length) {
  scriptjs(polyfillUrls, initTheme);
} else {
  initTheme();
}

const ageGatePage = document.getElementById('age-gate-page');

if (ageGatePage) {
  new SiteAgeGate(ageGatePage);
}
